import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import { Header } from "@/components/Header";
import { api } from "@/lib/api";
import { CalendarDays, ArrowLeft, Loader2 } from "lucide-react";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true)).finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#F7F6F2]">
      <Header />
      <div className="max-w-[760px] mx-auto px-4 md:px-8 py-12">
        <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm text-[#0077B6] font-medium mb-8 hover:underline" data-testid="back-to-blog"><ArrowLeft className="h-4 w-4" /> All articles</Link>
        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#1A365D]" /></div>
        ) : notFound || !post ? (
          <div className="text-center py-20 text-[#5C6660]">Article not found.</div>
        ) : (
          <article data-testid="blog-article">
            <div className="flex items-center gap-1.5 text-sm text-[#5C6660] mb-3"><CalendarDays className="h-4 w-4" />{new Date(post.created_at).toLocaleDateString()} · {post.author}</div>
            <h1 className="font-heading text-4xl font-medium tracking-tight text-[#1C211F] leading-tight mb-6">{post.title}</h1>
            {post.cover_image && <img src={post.cover_image} alt={post.title} className="w-full rounded-2xl mb-8" />}
            <div className="prose-blog text-[#2A312D] leading-relaxed" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.content || "") }} />
          </article>
        )}
      </div>
    </div>
  );
}
